var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatisNova3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "What is NOVA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Landing_page-1",
    transform: "translate(-211.000000, -912.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "What-is-NOVA",
    transform: "translate(211.000000, 912.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F63F40",
    strokeWidth: 3,
    cx: 64,
    cy: 102.453333,
    r: 11.8866667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F63F40",
    strokeWidth: 3,
    transform: "translate(97.444622, 44.518784) rotate(-30.000000) translate(-97.444622, -44.518784) ",
    cx: 97.4446222,
    cy: 44.5187843,
    r: 11.8866667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#F63F40",
    strokeWidth: 3,
    transform: "translate(30.729067, 44.398600) rotate(-60.113473) translate(-30.729067, -44.398600) ",
    cx: 30.7290667,
    cy: 44.3986,
    r: 11.9276052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7266667,100.666667 C82.9400454,98.3598547 89.3172077,93.9855525 94.0666667,88.0866667",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9266667,88.0533333 C38.6725489,93.9500806 45.0448029,98.324196 52.2533333,100.633333",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.26,55.5933333 C24.6578569,62.9954783 25.2628464,70.7050377 28,77.7666667",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.06,25.6666667 C50.5733638,26.8240985 43.5950391,30.1659948 38,35.2733333",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,35.2666667 C84.4041374,30.16175 77.4258915,26.8222106 69.94,25.6666667",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,77.7666667 C102.729153,70.7050678 103.327169,62.9980714 101.72,55.6",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatisNova3X);
export default __webpack_public_path__ + "static/media/What is NOVA@3x.0e835a934a4b971bf319271a01766dda.svg";
export { ForwardRef as ReactComponent };